var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDocumentAdd = function SvgDocumentAdd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#888D96",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.925 17.313H5.444a.833.833 0 0 1-.834-.833V3.86c0-.46.373-.833.834-.833h8.84c.528 0 .957.429.957.957v8.235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#888D96",
    strokeLinecap: "round",
    d: "M6.625 8.93h6.429M6.625 6.783h6.429M6.625 11.072h3.571M12 15.786h3.571m-1.786 1.785V14"
  })));
};
export default SvgDocumentAdd;